export default function getEnvironment() {
  return process.env.NODE_ENV;
}

export const getEnvItem = (variable) => {
  return process.env[`REACT_APP_${variable?.toLocaleUpperCase?.()}`] ?? '';
}